import { apiRoutes as authUser } from './modules/authUser';
import global from './global';
import auth from './auth';
import open from './open';
import { apiRoutes as moduleGlobal } from './modules/global';
import { apiRoutes as intelligence } from './modules/intelligence';
import moduleLegalCompliance from './modules/legalCompliance';
import moduleGlobalLegalCompliance from './modules/globalLegalCompliance';
import moduleCorrectiveActions from './modules/correctiveActions';
import { apiRoutes as lawFinder } from './modules/lawFinder';
import { apiRoutes as moduleBridgeFolder } from './modules/moduleBridgeFolder';
import { apiRoutes as chemicalTrading } from './modules/chemicalTrading';
import { apiRoutes as comsaReports } from './modules/comsaReports';
import { apiRoutes as comsaEnvironmental } from './modules/comsaEnvironmental';
import { apiRoutes as qseReports } from './modules/qseReports';
import { apiRoutes as saicaReports } from './modules/saicaReports';
import newsletterManager from './modules/newsletterManager';
import { apiRoutes as userManagement } from './modules/userManagement';
import { apiRoutes as communicationPipeline } from './modules/communicationPipeline';
import moduleResourceManager from './modules/resourceManager';
import inecoRiskManager from './modules/inecoRiskManager';
import moduleDocumentManager from './modules/documentManager';
import totalEnergiesRisk from './modules/totalEnergiesRisk';
import environmentalAspectsAssessment from './modules/environmentalAspectsAssessment';
import userQuery from './userQuery';
import chatbot from './chatbot';

export default {
  ...authUser,
  ...global,
  ...auth,
  ...open,
  ...moduleGlobal,
  ...intelligence,
  ...moduleLegalCompliance,
  ...moduleGlobalLegalCompliance,
  ...moduleCorrectiveActions,
  ...lawFinder,
  ...moduleBridgeFolder,
  ...chemicalTrading,
  ...comsaReports,
  ...comsaEnvironmental,
  ...qseReports,
  ...saicaReports,
  ...newsletterManager,
  ...userManagement,
  ...communicationPipeline,
  ...moduleResourceManager,
  ...inecoRiskManager,
  ...moduleDocumentManager,
  ...totalEnergiesRisk,
  ...environmentalAspectsAssessment,
  ...chatbot,
  ...userQuery,
};
